<template>
  <div class="container  mt-3">
    <div class="m-auto">
    	
      <div class="form-horizontal">
        
          <div class="form-group row">
            
            <label class="col-12 col-sm-4 col-form-label">Vigencia:</label>
            <div class="col-12 col-sm-4">
              <date-picker  class="date-picker" v-model="fechaVigencia" lang="es" type="date" 
            :time-picker-options="timePickerOptions" :clearable="true"></date-picker>
            </div>
            
            <div class="col-12 col-sm-4 mt-3 mt-sm-0">
              <button v-if="procesable" class="btn btn-block btn-danger" @click="procesarObservacion">
                Guardar Vigencia
              </button>   
            </div>
          </div>
      </div>
    </div>
    
    <b-modal @ok="procesar" @cancel="observacion=''" v-model="changeObservacion"  id="modalObservacion"
    :ok-disabled="observacion.length<observacionMin"  title="Motivo del cambio">
      <div class="mb-2">
        <b-form-textarea
          id="textarea"
          v-model="observacion"
          placeholder="Cuéntanos, ¿por qué es necesario hacer este cambio?"
          rows="3"
          max-rows="6"
          maxlength="100"
        ></b-form-textarea>
        <pre class="d-block text-right">{{ observacion.length }}/{{ observacionMin }}</pre>
      </div>
    </b-modal>

  </div>
</template>

<script>
  
  import Vue from 'vue';
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import DatePicker from 'vue2-datepicker'

  export default {
    name: 'DetalleVigencia',
    components: {
      DatePicker
    },
    data () {
      return {
        fechaVigencia: null,
        timePickerOptions:{},
        
        changeObservacion:false,
        observacionMin:10,
        observacion:''
      }
    },
    props: {
      estudiante: Object
    },
    mounted () {
      if(this.estudiante){
        // console.log(this.estudiante.vigencia)
        this.fechaVigencia = this.$moment(this.estudiante.vigencia).toDate();
        Vue.set(this, 'fechaVigencia', this.fechaVigencia)


      }else{
        console.log('Hay que asegurarse de tener un estudiante antes de utilizar el componente DetalleVigencia')
      }
    },
    methods:{
      ...mapActions({
        editarVigencia: 'estudiantes/editarVigencia',
        fetchDetalle: 'estudiantes/fetchDetalle',
        setWarning: 'setWarning',
      }),
      ...mapMutations({
        
      }),
      procesar(){
        let fecha_vigencia = this.fechaVigencia.toISOString().split('T')[0]

        this.editarVigencia({
          id:this.estudiante.id,
          vigencia:fecha_vigencia,
          observacion:this.observacion
        }).then((apiResponse)=>{
          
          this.limpiar()
          this.setWarning('Vigencia Guardada', { root: true }).then(()=>{
            this.fetchDetalle(this.estudiante.id).then((result)=>{
              this.fechaVigencia = this.$moment(result.vigencia).toDate();
              this.estudiante.vigencia = this.fechaVigencia;
            }) 
          })
          
          
        })
      },
      procesarObservacion(){
        this.changeObservacion = true;
        this.observacion = '';
      },
      limpiar(){
        this.fechaVigencia= null
        this.changeObservacion = false; 
        this.observacion = '';
      },
      
    },
    computed:{
      ...mapState({
        
      }),
      ...mapGetters({
        
      }),
      procesable: {
        get () {
          if (this.estudiante && this.estudiante.vigencia && this.fechaVigencia) {
            return this.fechaVigencia.toISOString() != new Date(this.estudiante.vigencia).toISOString();
          } else if (this.fechaVigencia)
          return true;
        },
        set(value){}
      },

    }
  }
</script>

<style scope>
  .programar_wrapper .form-container{
      
  }
	.programar_wrapper{
    
	}
</style>

